import React from 'react';

export const useContextHandling = <T,>(context: React.Context<T | null>, fallbackValue?: T): T => {
  const data = React.useContext(context);

  if (data === null) {
    if (fallbackValue) {
      return fallbackValue;
    }

    throw new Error(
      `Missing context: did you maybe forget wrapping your component with appropriate provider? (${
        context.displayName || context
      })`,
    );
  }

  return data;
};
